export async function isCameraPermissionPromptExpected(permissions: Permissions | undefined): Promise<boolean> {
  if (!permissions) return true;
  try {
    const permission = await permissions.query({ name: 'camera' as PermissionName });
    return permission.state === 'prompt';
  } catch {
    return true;
  }
}
